import { observable, action } from 'mobx';
import stores from '../../../models/Stores';

const { projectsLibraryStore: libraryStore } = stores.AppStore;

export class DownloadProjectImagesVM {
  @observable props;

  constructor(props: any) {
    this.props = props;
  }

  // ================================================ Selections ================================================
  @action.bound selectImage = (e, element) => {
    this.props.someChangesOnScreen();
    const i = libraryStore.selectedImages.indexOf(+e.target.value);
    if (e.target.checked) {
      if (i === -1) libraryStore.selectedImages.push(+e.target.value);
    } else {
      if (i > -1) libraryStore.selectedImages.splice(i, 1);
    }
    element.isSelected = !Object.keys(element.images).some((key) =>
      element.images[key].some((el) => !libraryStore.selectedImages.includes(el.structureProfilesId))
    );
  };

  @action.bound selectImageType = (e, data, element) => {
    this.props.someChangesOnScreen();
    selectImageTypeHandler(e.target.checked, data, element);
  };

  @action.bound selectStructure = (e, element) => {
    this.props.someChangesOnScreen();
    selectStructureHandler(e.target.checked, element);
  };
  // ================================================ //Selections ================================================
}

export const selectImageTypeHandler = (value, data, element) => {
  data.forEach((el) => {
    const i = libraryStore.selectedImages.indexOf(+el.structureProfilesId);
    if (value) {
      if (i === -1) libraryStore.selectedImages.push(el.structureProfilesId);
    } else {
      if (i > -1) libraryStore.selectedImages.splice(i, 1);
    }
  });
  element.isSelected = elementIsChecked(element);
};

export const selectStructureHandler = (value, element) => {
  Object.keys(element.images).forEach((key) => selectImageTypeHandler(value, element.images[key], element));
  element.isSelected = value;
};

export const elementIsChecked = (element) => {
  if (
    Object.keys(element.images).some((key) =>
      element.images[key].some((el) => !libraryStore.selectedImages.includes(el.structureProfilesId))
    )
  ) {
    return false;
  } else {
    return true;
  }
};
